import {AppRouterInstance, NavigateOptions} from "next/dist/shared/lib/app-router-context.shared-runtime";
import Util from "@/Master/Util";
import ShopMgr from "@/app/(shop)/ShopMgr";
import UserGlobalMgr from "@/Core/UserGlobalMgr";
import ChannelMgr from "@/Fwk/Channel/ChannelMgr";

export default class RouterMgr {

    static tag = '[路由Mgr]';
    static router:AppRouterInstance;

    static Init(router: AppRouterInstance, pathname: string){
        this.router = router;
        if (Util.isLog){
            console.log(this.tag,'Init router:',router);
            console.log(this.tag,'Init pathname:',pathname);
        }
    }

    static push(href: string, options?: NavigateOptions){
        this.router.push(href,options);
    }

    static back(){
        this.router.back();
    }

    static home(){
        this.router.push('/'+ChannelMgr.getQid);
    }

    static shop(){
        this.router.push('/store'+ChannelMgr.getQid);
    }

    static login(params?:[string, string][]){
        const newPar = ChannelMgr.getNewParam();
        if (params){
            for (let i = 0; i < params.length; i++) {
                const arr = params[i];
                newPar.set(arr[0],arr[1]);
            }
        }
        this.router.push(`/login?${newPar.toString()}`);
    }

    static signup(params?:[string, string][]){
        const newPar = ChannelMgr.getNewParam();
        if (params){
            for (let i = 0; i < params.length; i++) {
                const arr = params[i];
                newPar.set(arr[0],arr[1]);
            }
        }
        this.router.push(`/signup?${newPar.toString()}`);
    }

    static refresh(){
        this.router.refresh();
    }

    static replace(value:string){
        this.router.replace(value);
    }

    static onPathnameChange(pathname: string) {
        if (Util.isLog){
            console.log('路由发生了变化:', pathname);
        }
        //校验是否强制显示去登陆的弹窗
        ShopMgr.checkShowRegDialog();

        UserGlobalMgr.updateUserBaseInfo();
    }
}